import { StringCoercible } from './StringCoercible';
import { ScaleWithValueType } from './SupportedScale';

/**
 * Returns a set of generated ticks for the given scale, given an approximate number of ticks to
 * generate.
 *
 * For scales that support tick generation (i.e., a `ticks` method), the scale is used to generate
 * its own ticks. For band scale, the ordinal domain is used as-is.
 *
 * @param scale The scale to use to generate ticks.
 * @param tickCount The approximate number of ticks to generate. This value is only approximate, and
 * may not have any effect depending on the scale.
 */
// FIXME: hardcoded return type is not right; should depend on type parameters
export function getTicks<TValueType>(
  scale: ScaleWithValueType<TValueType>,
  tickCount?: number,
): number[] | StringCoercible[] {
  // number scale: use the `ticks` method
  if (typeof scale.ticks === 'function') {
    return scale.ticks(tickCount);
  }

  // ordinal scale: use the domain
  return scale.domain();
}
